import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-ficha',
  templateUrl: './main-ficha.component.html',
  styleUrls: ['./main-ficha.component.css']
})
export class MainFichaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
